module.exports = require("./lg-UG.js");